import { number as o } from "./atoms-v21098.js";
import { px as r, percent as m, degrees as t, vw as i, vh as n } from "./atoms-v2960.js";
import { testValueType as p } from "./atoms-v21104.js";
import { auto as s } from "./atoms-v21203.js";
const f = [o, r, m, t, i, n, s], l = (e) => f.find(p(e));
export {
  f as dimensionValueTypes,
  l as findDimensionValueType
};
